import { type FC, type ReactNode } from 'react'
import classnames from 'classnames'
import styles from './styles.module.scss'

type ISectionColumnProps = {
  className?: string
  classNameContent?: string
  classNameHeader?: string
  renderHeader: ReactNode
  children: ReactNode
  isEmpty?: boolean
}

export const SectionColumn: FC<ISectionColumnProps> = ({
  className,
  classNameContent,
  classNameHeader,
  renderHeader,
  children,
  isEmpty,
}) => {
  if (isEmpty) {
    return <div className={classnames(styles.wrap, className)} />
  }

  return (
    <div className={classnames(styles.wrap, className)}>
      <div className={classnames(styles.header, classNameHeader)}>{renderHeader}</div>
      <div className={classnames(styles.content, classNameContent)}>{children}</div>
    </div>
  )
}
